import { SET_TENANT_SETTINGS } from "./types";
import TenantService from "../services/TenantService";

/**
 * Fetch tenant settings (incl. per-tenant fee config) and store them.
 * Falls back silently to the reducer defaults if the request fails.
 */
export const fetchTenantSettings = () => async (dispatch) => {
    try {
        const { data } = await TenantService.getTenantInfo();
        dispatch({
            type: SET_TENANT_SETTINGS,
            payload: {
                percentage: data.platform_fee_percentage,
                fixed: data.platform_fee_fixed,
                groupTrainsByDate: data.group_trains_by_date,
            },
        });
    } catch (err) {
        console.log(err);
    }
};
